/* eslint global-require: "off" */

import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { asyncConnect } from 'redux-connect';
import { connect } from 'react-redux';

// import commonUtil from '../../utils/commonUtil';

import * as labelsActions from '../../components/labels/actions';

const { isLablesLoaded, helthCheck } = labelsActions;
const _env = process.env.NODE_ENV;

const _myVar = {};
_myVar.NODE_ENV = typeof env !== 'undefined' ? env.NODE_ENV : process.env.NODE_ENV;// eslint-disable-line no-undef
_myVar.PORT = typeof env !== 'undefined' ? env.PORT : process.env.PORT;// eslint-disable-line no-undef
_myVar.INSTANCE_NAME = typeof env !== 'undefined' ? env.INSTANCE_NAME : process.env.INSTANCE_NAME;// eslint-disable-line no-undef

const MY_VAR = typeof window !== 'undefined' ? window.env : (_myVar);


const instanceName = MY_VAR.INSTANCE_NAME; // process.env.INSTANCE_NAME ? process.env.INSTANCE_NAME : '-Unknown-';

@asyncConnect([{
  deferred: false,
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(helthCheck());
    }
    return undefined;
  },
},
])

@connect(store => ({
  lables: store.labels,
  // error: store.labels.error,
  loading: store.labels.loading,
}),
  { ...labelsActions })

export default class Instancecheck extends Component {

  state = {
    showKitten: false,
  }

  handleToggleKitten = () => this.setState({ showKitten: !this.state.showKitten })

  render() {
    const { lables } = this.props;
    // if (!lables) {
    //   return null;
    // } else if (error) {
    //   return null;  // Error from Service...........
    // }
    return (
      <div className="container-fluid">
        <script dangerouslySetInnerHTML={{ __html: 'env = ' + (JSON.stringify(MY_VAR)) + '' }} />
        <Helmet title="Health Check page........" />
        <h1>
          GR - Web online up and running.......................
        </h1>
        <h3>
          Testing static lable service <br />
        </h3>
        <table>
          <tr>
            <td>
              current environment : {_env}
            </td>
            <td>
              current instance Name : {instanceName}
            </td>
          </tr>
          <tr>
            <td>
              Oracel server
            </td>
            <td>
              {lables.data.server}
            </td>
          </tr>
          <tr>
            <td>
              x-oracle-dms-ecid
            </td>
            <td>
              {lables.data['x-oracle-dms-ecid']}
            </td>
          </tr>
          <tr>
            <td>
              x-oracle-dms-rid
            </td>
            <td>
              {lables.data['x-oracle-dms-rid']}
            </td>
          </tr>
          <tr>
            <td>
              x-atg-version
            </td>
            <td>
              {lables.data['x-atg-version']}
            </td>
          </tr>
          <tr>
            <td>
              gr hostname
            </td>
            <td>
              {lables.data['gr-hostname']}
            </td>
          </tr>
          <tr>
            <td>
              via
            </td>
            <td>
              {lables.data.via}

            </td>
          </tr>

          {/* <tr>
            <td>
              home.clebration.event.description key ::
            </td>
            <td>
              <span dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.home, 'home.clebration.event.description') }} />
            </td>
          </tr> */}
        </table>
      </div>
    );
  }
}
